export const MakeConfig = (
  {
    config,
    brokerFriendlyName
  }
) => {
  const defaultSettings = {
    meta: {
      brand: config.theme.brand,
      seo: config.theme.seo
    },
    tool: {
      brandConfig: config,
      staffMode: false,
      brokerFriendlyName,
      staffName: '',
      useMocks: false,
      env: process.env.REACT_APP_ENV
    }
  };

  return {
    public: defaultSettings,
    local: {
      ...defaultSettings,
      tool: {
        ...defaultSettings.tool,
        useMocks: true
      }
    },
    staff: {
      ...defaultSettings,
      tool: {
        ...defaultSettings.tool,
        staffMode: true
      }
    }
  };
};